import { render, staticRenderFns } from "./ObiInput.vue?vue&type=template&id=04a3cb42&scoped=true&"
import script from "./ObiInput.vue?vue&type=script&lang=js&"
export * from "./ObiInput.vue?vue&type=script&lang=js&"
import style0 from "./ObiInput.vue?vue&type=style&index=0&id=04a3cb42&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04a3cb42",
  null
  
)

export default component.exports